export default "__VITE_ASSET__DA$nAjl0__"